import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Selected timeframe")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Last year")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Last 6 months")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Last 7 days")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Last 24 hours")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Last 6 hours")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Select specific day")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Selected date")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_grid, { style: {"height":"90%","display":"flex","flex-flow":"column"} }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { style: {"flex-grow":"1"} }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        modelValue: _ctx.selected,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
                        placeholder: "Select One",
                        interface: "popover"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "from=now-1y&to=now&var-groupby=1d" }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "from=now-6M&to=now&var-groupby=1d" }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "from=now-7d&to=now&var-groupby=1min" }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "from=now-24h&to=now&var-groupby=1min" }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "from=now-6h&to=now&var-groupby=1min" }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "calendar" }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_ctx.selected == 'calendar' ? true : false)
                    ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_datetime, {
                            "display-format": "DD MM YY",
                            placeholder: "Select Date",
                            value: _ctx.fromDateIso,
                            onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleDateChange($event.detail.value)))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default", { timeFrame: _ctx.timeFrame })
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}